/* eslint-disable camelcase */
import { queryStringFromObj } from 'utils/urlParser';
import HttpRequest from '../HttpRequest';
import ENDPOINTS, { RETURNS_DEFAULT_PARAMS } from './constants';

export default class OrderManagementApi extends HttpRequest {


  getReturnsData({ params = {} }) {
    const requestParams = {
      ...RETURNS_DEFAULT_PARAMS,
      ...params,
    };

    const queryString = queryStringFromObj(requestParams);
    return this.call(`${ENDPOINTS.ORDER_RETURN}${queryString}`);
  }

  addReturn({ params = {} }) {
    const { 
    sales_order_number, guid_order_line,return_qty,reason,next_action,notes,custom_reason 
    } = params.returnData;
    const bodyFormData = new FormData();
    bodyFormData.set('sales_order_number', sales_order_number);
    bodyFormData.set('guid_order_line', guid_order_line);
    bodyFormData.set('return_qty', return_qty);
    bodyFormData.set('sales_order_number', sales_order_number);
    bodyFormData.set('reason', reason);
    bodyFormData.set('next_action', next_action);
    bodyFormData.set('notes', notes);

    if (reason === 7 && custom_reason) {
      bodyFormData.set('custom_reason', custom_reason);
    }

    return this.call(ENDPOINTS.ADD_RETURN, {
      method: 'POST',
      data: bodyFormData,
    });
  }
}

export { ENDPOINTS };
